import classNames from 'classnames';
import { createElement, PropsWithChildren } from 'react';
import * as styles from './Typography.module.scss';

type Props = {
  className?: string;
  color?: 'error' | 'inverse' | 'secondary';
  component?: 'div' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'p';
  mb?: '8' | '12' | '16' | '24' | '32' | '48' | '64';
  variant?:
    | 'heading100'
    | 'heading200'
    | 'heading300'
    | 'heading400'
    | 'heading500'
    | 'heading600'
    | 'heading700'
    | 'paragraph100'
    | 'paragraph200'
    | 'paragraph300'
    | 'text100'
    | 'text100bold'
    | 'text200'
    | 'text200bold'
    | 'text300'
    | 'text300bold';
};

function getVariantKey(variant: Props['variant']) {
  // because of css-loader exportLocalsConvention camelCase the B is uppercase
  if (variant === 'text100bold') {
    return 'text100Bold';
  }

  if (variant === 'text200bold') {
    return 'text200Bold';
  }

  if (variant === 'text300bold') {
    return 'text300Bold';
  }
  return variant;
}

// loosely based upon https://mui.com/components/typography/
export default function Typography({ children, className, color, component = 'span', mb, variant }: PropsWithChildren<Props>) {
  const variantClassName = variant && styles[getVariantKey(variant)];

  // because of css-loader exportLocalsConvention camelCase the X is uppercase
  // Maybe we should see what library/logic css-loader uses for camel-casing and clone that here?
  const mbClassName = mb && styles[`mb${mb}`];
  const colorClassName = color && styles[color];
  return createElement(component, { className: classNames(variantClassName, mbClassName, colorClassName, className) }, children);
}
